/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { SessionClosePolicy } from '../models/SessionClosePolicy';
import type { TagData } from '../models/TagData';
import type { VehicleId } from '../models/VehicleId';
import type { VehicleSession } from '../models/VehicleSession';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class VehicleSessionService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get my open vehicle session
     * Get my open vehicle session
     * @returns VehicleSession My open vehicle session
     * @throws ApiError
     */
    public vehicleSessionGet(): Observable<VehicleSession> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/me/vehicle_session',
            errors: {
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Open my vehicle session
     * Open my vehicle session
     * @param requestBody
     * @returns any The session
     * @throws ApiError
     */
    public vehicleSessionOpen(
        requestBody: {
            close_policy: SessionClosePolicy;
            tag: TagData;
        },
    ): Observable<(VehicleSession & {
        /**
         * Sessions closed by this sign-in
         */
        displaced: Array<{
            /**
             * Close reason
             */
            close_reason: 'displaced' | 'policy';
            /**
             * When it ended
             */
            ended_at: string;
            /**
             * The caller's own session
             */
            is_own_session: boolean;
            vehicle_id: VehicleId;
        }>;
    })> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/me/vehicle_session',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `Not found`,
                410: `Expired`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Close my vehicle session
     * Close my vehicle session
     * @returns void
     * @throws ApiError
     */
    public vehicleSessionClose(): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/me/vehicle_session',
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
